import {Vue, createApp} from 'vue'
// import {createPinia} from 'pinia'
import App from 'client/components/app.vue'
// import Router from 'client/js/router.js'
// import store from 'client/js/store/store.js'

// Extra Style/Layout specific global components
// Vue.component('PageFooter', require('client/components'))
class VueJSUI {
   static init(baseUrl) {
      // const router = Router.init(baseUrl)
      createApp(App)
         // .use(createPinia())
         // .use(router)
         .mount('#main-content')
   }
}

module.exports = VueJSUI
